import React, { useState, useRef } from 'react';

const DataImport = () => {
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);
  const [activeTab, setActiveTab] = useState('clients');
  const fileRef = useRef(null);
  const getHeaders = () => ({ 'Authorization': `Bearer ${localStorage.getItem('token') || localStorage.getItem('nomokratia_token')}` });

  const handleImport = async () => {
    const file = fileRef.current?.files?.[0];
    if (!file) return;
    setImporting(true);
    setResult(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const endpoint = activeTab === 'clients' ? '/api/crm/import/clients' : '/api/crm/import/cases';
      const res = await fetch(endpoint, { method: 'POST', headers: getHeaders(), body: formData });
      const data = await res.json();
      setResult(data);
    } catch (e) {
      setResult({ success: false, errors: [e.message] });
    } finally {
      setImporting(false);
    }
  };

  const downloadTemplate = () => {
    let csv;
    if (activeTab === 'clients') {
      csv = 'firstName;lastName;email;phone;afm;company;address;city;doy;profession;notes\nΝίκος;Παπαδόπουλος;nikos@example.gr;2310111111;111111111;Παπαδόπουλος ΟΕ;Τσιμισκή 50;Θεσσαλονίκη;Α Θεσσαλονίκης;Έμπορος;Σημειώσεις';
    } else {
      csv = 'title;client_name;case_type;court;case_number;status;description;notes\nΑγωγή αποζημίωσης;Παπαδόπουλος ΟΕ;Αστικό;ΜΠΘ;ΓΑΚ 1234/2026;active;Αγωγή λόγω αθέτησης σύμβασης;';
    }
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = activeTab === 'clients' ? 'template_pelates.csv' : 'template_ypotheseis.csv';
    a.click();
  };

  const s = {
    container: { padding: '20px' },
    title: { fontSize: '22px', fontWeight: '700', color: '#1a365d', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '10px' },
    subtitle: { color: '#4a5568', fontSize: '14px', marginBottom: '24px' },
    tabs: { display: 'flex', gap: '0', marginBottom: '24px', borderBottom: '2px solid #e2e8f0' },
    tab: (active) => ({ padding: '10px 24px', cursor: 'pointer', fontWeight: active ? '600' : '400', color: active ? '#2b6cb0' : '#4a5568', borderBottom: active ? '2px solid #2b6cb0' : '2px solid transparent', marginBottom: '-2px', background: 'none', border: 'none', fontSize: '15px' }),
    card: { background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', padding: '24px', marginBottom: '20px' },
    uploadArea: { border: '2px dashed #cbd5e0', borderRadius: '12px', padding: '40px', textAlign: 'center', cursor: 'pointer', background: '#f7fafc', transition: 'all 0.2s' },
    btn: { background: '#2b6cb0', color: '#fff', border: 'none', padding: '10px 24px', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' },
    btnOutline: { background: '#fff', color: '#2b6cb0', border: '1px solid #2b6cb0', padding: '8px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
    success: { background: '#f0fff4', border: '1px solid #c6f6d5', borderRadius: '8px', padding: '16px', marginTop: '16px' },
    error: { background: '#fff5f5', border: '1px solid #fed7d7', borderRadius: '8px', padding: '16px', marginTop: '16px' },
    columns: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginTop: '20px' },
    colCard: { background: '#f7fafc', borderRadius: '8px', padding: '16px', border: '1px solid #e2e8f0' },
    colTitle: { fontWeight: '600', color: '#2d3748', marginBottom: '8px', fontSize: '14px' },
    colList: { fontSize: '13px', color: '#4a5568', lineHeight: '1.8' },
  };

  const clientCols = ['firstName / Όνομα', 'lastName / Επώνυμο', 'email / Email', 'phone / Τηλέφωνο', 'mobile / Κινητό', 'afm / ΑΦΜ', 'company / Εταιρεία', 'address / Διεύθυνση', 'city / Πόλη', 'zip / ΤΚ', 'doy / ΔΟΥ', 'profession / Επάγγελμα', 'notes / Σημειώσεις'];
  const caseCols = ['title / Τίτλος', 'client_name / Πελάτης', 'case_type / Τύπος', 'court / Δικαστήριο', 'case_number / Αριθμός', 'status / Κατάσταση', 'description / Περιγραφή', 'notes / Σημειώσεις'];

  return (
    <div style={s.container}>
      <div style={s.title}>📥 Εισαγωγή Δεδομένων</div>
      <div style={s.subtitle}>Εισαγωγή πελατών και υποθέσεων από CSV/Excel αρχεία</div>

      <div style={s.tabs}>
        <button style={s.tab(activeTab === 'clients')} onClick={() => { setActiveTab('clients'); setResult(null); }}>👤 Πελάτες</button>
        <button style={s.tab(activeTab === 'cases')} onClick={() => { setActiveTab('cases'); setResult(null); }}>📂 Υποθέσεις</button>
      </div>

      <div style={s.card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ fontWeight: '600', color: '#2d3748' }}>
            {activeTab === 'clients' ? '📋 Εισαγωγή Πελατών' : '📋 Εισαγωγή Υποθέσεων'}
          </div>
          <button style={s.btnOutline} onClick={downloadTemplate}>
            ⬇ Κατέβασε Template
          </button>
        </div>

        <div style={s.uploadArea} onClick={() => fileRef.current?.click()}>
          <input type="file" ref={fileRef} accept=".csv,.txt,.tsv" style={{ display: 'none' }} onChange={() => setResult(null)} />
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>📄</div>
          <div style={{ fontWeight: '600', color: '#2d3748', marginBottom: '4px' }}>
            Σύρε ή κάνε κλικ για να ανεβάσεις αρχείο
          </div>
          <div style={{ fontSize: '13px', color: '#718096' }}>
            CSV με ; ή , separator · UTF-8 encoding · Ελληνικά ή Αγγλικά headers
          </div>
          {fileRef.current?.files?.[0] && (
            <div style={{ marginTop: '12px', color: '#2b6cb0', fontWeight: '600' }}>
              ✓ {fileRef.current.files[0].name}
            </div>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <button style={{ ...s.btn, opacity: importing ? 0.6 : 1 }} onClick={handleImport} disabled={importing}>
            {importing ? '⏳ Εισαγωγή...' : '🚀 Εισαγωγή'}
          </button>
        </div>

        {result && result.success && (
          <div style={s.success}>
            <strong>✅ Εισαγωγή ολοκληρώθηκε!</strong><br />
            {result.imported} εγγραφές εισήχθησαν {result.errors?.length > 0 && `· ${result.errors.length} σφάλματα`}
            {result.errors?.length > 0 && (
              <div style={{ marginTop: '8px', fontSize: '13px', color: '#c53030' }}>
                {result.errors.map((e, i) => <div key={i}>⚠ {e}</div>)}
              </div>
            )}
          </div>
        )}
        {result && !result.success && (
          <div style={s.error}>
            <strong>❌ Σφάλμα</strong><br />
            {result.errors?.join(', ') || result.message || 'Άγνωστο σφάλμα'}
          </div>
        )}
      </div>

      <div style={s.columns}>
        <div style={s.colCard}>
          <div style={s.colTitle}>📋 Αποδεκτές Στήλες {activeTab === 'clients' ? 'Πελατών' : 'Υποθέσεων'}</div>
          <div style={s.colList}>
            {(activeTab === 'clients' ? clientCols : caseCols).map((c, i) => (
              <div key={i}>• <code style={{ background: '#edf2f7', padding: '1px 4px', borderRadius: '3px', fontSize: '12px' }}>{c.split(' / ')[0]}</code> — {c.split(' / ')[1]}</div>
            ))}
          </div>
        </div>
        <div style={s.colCard}>
          <div style={s.colTitle}>💡 Οδηγίες</div>
          <div style={s.colList}>
            <div>• Αποθήκευσε το Excel ως CSV (UTF-8)</div>
            <div>• Η πρώτη γραμμή πρέπει να είναι headers</div>
            <div>• Separator: <code>;</code> (semicolon) ή <code>,</code> (comma)</div>
            <div>• Ελληνικά ή αγγλικά ονόματα στηλών</div>
            <div>• Κενά πεδία επιτρέπονται</div>
            <div>• Κατέβασε το template για παράδειγμα</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataImport;
